<template>
  <div style="padding-top: 20px">
    <div class="title">
      <div v-if="max == null">{{ name }}建议摄入{{ min }}{{ units }}以上</div>
      <div v-else-if="min == null">
        {{ name }}建议摄入{{ max }}{{ units }}以下
      </div>
      <div v-else-if="min != max">
        {{ name }}建议摄入{{ min }}-{{ max }}{{ units }}
      </div>
      <div v-else>{{ name }}</div>
      <div>摄入{{ number }}{{ units }}</div>
    </div>
    <div class="triangleDiv">
      <div class="triangle" :style="triangleLeft"></div>
    </div>
    <div class="div">
      <div class="Ycol" :style="Ysize"></div>
      <div class="Gcol" :style="Gsize"></div>
      <div class="Rcol" :style="Rsize"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    units: String,
    min: Number,
    max: Number,
    number: Number,
  },
  data() {
    return {};
  },
  computed: {
    Ysize: function () {
      if (this.min == 0 || this.min == null) {
        return "width:0%";
      } else if (this.min == 0) {
        return "width:calc(100% / 3)";
      }
    },
    Gsize: function () {
      if (
        (this.min == null && this.max == null) ||
        (this.min == 0 && this.max == 0)
      ) {
        return "width:calc(100%)";
      } else if (
        this.min == 0 ||
        this.min == null ||
        this.max == 0 ||
        this.max == null
      ) {
        return "width:calc(100% / 3 * 2)";
      } else {
        return "width:calc(100% / 3)";
      }
    },
    Rsize: function () {
      if (this.min == 0 && this.max == 0) {
        return "width:0%";
      } else if (this.max == 0 || this.max == null) {
        return "width:0%";
      } else {
        return "width:calc(100% / 3)";
      }
    },
    triangleLeft: function () {
      if (this.number < this.min) {
        return "margin-left:0";
      } else if (this.max == null) {
        return "margin-left:72%";
      } else if (this.number <= this.max || this.min == this.max) {
        return "margin-left:50%";
      } else {
        return "margin-left:90%";
      }
    },
  },
  created() {},
  methods: {},
};
</script>


<style lang="less" scoped>
.div {
  width: 303px;
  height: 8px;
  margin: 0 auto;
  margin-top: 5px;
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  div {
    width: calc(100% / 3);
  }
}
.Ycol {
  background: #fbd461;
  border: #fbd461;
}
.Gcol {
  background: #4bd891;
  border: #4bd891;
}
.Rcol {
  background: #f2786d;
  border: #f2786d;
}
.title {
  width: 300px;
  margin: 0 auto;
  font-size: 10px;
  font-weight: 400;
  color: #606060;
  display: flex;
  justify-content: space-between;
}
.triangleDiv {
  width: 213px;
  height: 8px;
  margin: 0 auto;
  margin-top: 3px;
  display: flex;
  justify-content: space-between;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #4ec087;
}
</style>